<template>
  <div>
    <div v-if="canEditTags" class="tag-selector is-flex">
      <div class="category-button has-text-grey is-flex cursor-pointer" tabindex="0" @keypress.enter.space="toggleTagInput" @click="toggleTagInput">
        <span class="icon plus-btn" qa="add-tag-btn">
          <i v-if="!showTagInput" class="fal fa-plus-circle has-text-primary" aria-hidden="true"></i>
          <i v-else class="fal fa-times" aria-hidden="true"></i>
        </span>
        <span v-if="label" class="is-uppercase">{{ $t('projectPage.add') }} {{ label.substring(0, label.length - 1) }}</span>
        <span v-else>{{$t('projectPage.customTag')}}</span>
      </div>
      <div v-if="showTagInput" class="dropdown">
        <input class="text dropdown-item" placeholder="Add a custom tag" v-model.trim="tagSearch" @keypress.enter.space="addTag" data-lpignore="true">
        <i v-if="tagSearch" class="fal fa-plus-circle has-text-primary" aria-hidden="true" @click="addTag"></i>
      </div>
      <div v-for="(tag, offset) in chosenTags" :key="offset" class="tag" :class="{'has-tags' : chosenTags && chosenTags.length, 'is-duplicate' : offset === duplicateIndex }" :data-tag="tag" :data-offset="offset" draggable="true" @dragstart="drag" @dragover="allowDrop" @drop="drop">
        {{'#' + tag }}
        <button class="delete is-small" @click="removeTag(tag)"></button>
      </div>
      <div v-if="error && chosenTags.length >= 5 && !this.$isYSC" class="help has-text-grey">{{error}}</div>
    </div>

    <div v-if="isYSCPortalUser">
      <div class="category-button has-text-grey is-flex">
        <span style="cursor:default">{{$t('projectPage.customTag') + " |"}}</span>&nbsp;
        <span class="hover-link mr-2" style="cursor:pointer; color: red;" @click="openURL(yscPortalLink)">{{$t('projectPage.customTagIsportalNotice')}}</span>
      </div>
      <div>
        <div v-for="(tag, offset) in chosenTags" :key="offset" style="cursor:default" class="tag" :class="{'has-tags' : chosenTags && chosenTags.length, 'is-duplicate' : offset === duplicateIndex }" :data-tag="tag" :data-offset="offset" @dragstart="drag" @drop="drop">
        {{'#' + tag }}
        </div>
        <div v-if="error && chosenTags.length >= 5 && !this.$isYSC" class="help has-text-grey">{{error}}</div>
      </div>
    </div>
    <div v-if="!showTags">
      <div class="category-button has-text-grey is-flex">
        <span style="cursor:default">{{$t('projectPage.customTag') + " |"}}</span>&nbsp;
        <div v-for="(tag, offset) in chosenTags"
             :key="offset"
             style="cursor:default"
             class="tag"
             :class="{'has-tags' : chosenTags && chosenTags.length, 'is-duplicate' : offset === duplicateIndex }"
             :data-tag="tag"
             :data-offset="offset"
             @dragstart="drag"
             @drop="drop">
        {{'#' + tag }}
        </div>
        <div v-if="error && chosenTags.length >= 5 && !this.$isYSC" class="help has-text-grey">{{error}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n'
import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'
import state from '../../SectionProjectView/state'

export default {
  mixins: [auth, componentState],
  props: {
    chosenTags: {
      type: Array,
      default: function () {
        return []
      }
    },
    label: String
  },
  data: function () {
    return {
      tagSearch: '',
      tags: [],
      dragging: { to: null, from: null },
      isFocusedInput: false,
      showTagInput: false,
      duplicateIndex: -1,
      error: '',
      isPortal: false
    }
  },
  watch: {
    chosenTags: function () {
      this.$emit('input', this.chosenTags)
    }
  },
  computed: {
    yscPortalLink: function () {
      return this.$t('projectPage.yscPortalLink')
    },
    addCustomTagHere: function () {
      return i18n.t('projectPage.addCustomTag')
    },
    showTags: function () {
      if (this.$parent.project) {
        if (this.$parent.project.partner.id === 8 && !this.hasAdminPermission) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    canEditTags: function () {
      return this.hasAdminPermission || (!this.$isYSC && !this.$isAjas && !this.isPortal && this.showTags)
    },
    projectRole: function () {
      return this._get(state.project.role)
    },
    hasAdminPermission: function () {
      return this.isAdmin || this.projectRole === 'anonAdmin' || this.projectRole === 'anonCoordinator'
    },
    isYSCPortalUser: function () {
      return this.isPortal && this.$isYSC && !this.hasAdminPermission
    }
  },
  mounted: function () {
    if (this.$root.$store.getters.currentUser) {
      this.isPortal = this.$root.$store.getters.currentUser.isPortal
    }
  },
  methods: {
    toggleTagInput: function () {
      if (this.showTagInput === true) {
        this.showTagInput = false
        this.error = ''
      } else {
        this.showTagInput = true
      }
    },
    addTag: function () {
      if (this.chosenTags.length >= 5 && !this.$isYSC) {
        this.error = 'You have reached your tag limit. Remove a tag if you would like to add another.'
        return
      }
      let tag = this.tagSearch
      tag = tag.replace(/[!@#$%^&*(){}[\]_="';:/?.>,<]+/g, '')
      if (tag.length === 0) {
        this.tagSearch = ''
        return
      }
      this.duplicateIndex = this.chosenTags.indexOf(tag)
      if (this.duplicateIndex >= 0) {
        return
      }
      this.chosenTags.push(tag)
      this.tagSearch = ''
    },
    removeTag: function (tag) {
      this.chosenTags.splice(this.chosenTags.indexOf(tag), 1)
    },
    drag: function (event) {
      this.dragging.from = parseInt(event.target.dataset.offset)
    },
    canDrop: function (to) {
      return !isNaN(to) && this.dragging.from !== null && this.dragging.from !== to
    },
    openURL: function (url) {
      if (url.substring(0, 4) !== 'http' && url.substring(0, 1) !== '/') {
        url = `http://${url}`
      }
      window.open(url, '_blank')
    },
    allowDrop: function (event) {
      const to = parseInt(event.target.dataset.offset)
      if (this.canDrop(to)) {
        event.preventDefault()
        this.dragging.to = to
        this.drop(event)
      }
    },
    drop: function (event) {
      event.preventDefault()
      this.chosenTags.splice(this.dragging.to, 0, this.chosenTags.splice(this.dragging.from, 1)[0])
      this.dragging.from = this.dragging.to
      this.dragging.to = null
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .category-button {
    margin: 0.5rem 0;
    margin-right: 0.5rem;
    font-size: 0.7rem;
    align-items: center;
    .icon {
      font-size: 1.25rem;
    }
  }
  .tag-selector {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    align-items: center;
  }
  .dropdown {
    height: 1.75rem;
    display: flex;
    align-items: center;
    i {
      cursor: pointer;
      margin-right: .5rem;
    }
    input:focus {
      outline-color: $primary;
    }
  }
  .plus-btn {
    i {
      font-size: 1.5rem;
    }
    cursor: pointer;
  }
  .portal-btn {
    i {
      font-size: 1.5rem;
    }
    cursor: default;
  }
  .tag {
    cursor: move;
    margin: 0.15rem 0.3rem 0.15rem 0;
    background: whitesmoke;
    border-radius: 2px;
    border: 1px solid $grey-light;
    .delete {
      cursor: pointer;
      background-color: $primary;
      padding: 0;
    }
  }
  .has-tags {
    margin-right: .5rem;
  }
  .is-duplicate {
    background: $secondary;
    color: white;
    .delete {
      background: $secondary;
    }
  }
  .dropdown .text {
    border: solid 1px $grey-lighter;
    margin-right: 1.5em;
    border-radius: 4px;
  }
  .dropdown-item {
    padding-left: 0.25rem;
    font-size: 0.7rem;
    padding-right: 0;
    width: 190px;
  }
  .category-button {
    .icon {
      margin-right: 0.5rem;
    }
  }

  .hover-link:hover {
  text-decoration: underline;
}

</style>
